let lastEvent = null;

export function installInteractionTracker() {
    if (typeof window === 'undefined' || window.__interactionTrackerInstalled) return;
    window.__interactionTrackerInstalled = true;

    window.addEventListener('click', (e) => {
        const target = e.target instanceof Element ? e.target : null;
        if (!target) return;
        lastEvent = {
            targetRef: typeof WeakRef === 'function' ? new WeakRef(target) : null,
            target: typeof WeakRef === 'function' ? null : target,
            at: performance.now(),
            iso: null,
        };
        lastEvent.iso = new Date().toISOString();
    }, true);
}

function resolveLastClick() {
    if (!lastEvent) return undefined;
    const target = lastEvent.targetRef ? lastEvent.targetRef.deref() : lastEvent.target;
    if (!target || !target.isConnected) return undefined;
    const dataIdEl = target.closest('[data-id]');
    const clickable = target.closest('button, a, tr, [role="button"]') || target;
    const text = (clickable.getAttribute?.('aria-label') || clickable.getAttribute?.('title') || clickable.textContent || '').trim().slice(0, 80);
    return {
        at: lastEvent.iso,
        tag: clickable.tagName,
        id: clickable.id || undefined,
        dataId: dataIdEl?.dataset?.id,
        text: text || undefined,
    };
}

// 빌드 시 vite define으로 주입되는 배포 빌드 식별자("<git hash> @ <빌드시각>").
// 여러 호스트가 서로 다른 시점에 배포되므로, 어떤 빌드에서 난 에러인지 특정하는 데 사용한다.
const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';

export function getInteractionContext() {
    return {
        route: location.hash || location.pathname,
        host: location.host,
        app: APP_VERSION,
        lastClick: resolveLastClick(),
    };
}
